import AxiosUtil from '../utils/axiosUtil';

/** 조기폐차 점검번호 미리보기 */
const INSPECT_NUMBER_URI = '/apis/early-scrap';
/** 조기폐차 확인서 등록 */
const REGISTER_URI = '/apis/performance-checks/data/early';

export const EarlyScrapService = (function () {
  let instance;

  function init() {
    return {
      /** 점검번호 미리보기: YYYYMMDD + 4자리 순번(0001~9999). 실제 채번은 등록 시 수행. */
      getNextInspectNumber: async function ({ shopId } = {}) {
        const query = shopId != null ? `shopId=${shopId}` : '';
        return await AxiosUtil.Async.get(
          `${INSPECT_NUMBER_URI}/inspect-number/next`,
          query
        );
      },
      register: async function (data, files = null) {
        return await AxiosUtil.Async.multipart(REGISTER_URI, data, files);
      },
      update: async function (data, files = null) {
        return await AxiosUtil.Async.updateMultipart(REGISTER_URI, data, files);
      },
      delete: async function (dataId) {
        return await AxiosUtil.Async.delete(`${REGISTER_URI}/${dataId}`);
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();
